'use client';

import React from 'react';

interface CardProps {
  children: React.ReactNode;
  className?: string;
  hover?: boolean;
  glow?: boolean;
}

const Card: React.FC<CardProps> = ({
  children,
  className = '',
  hover = false,
  glow = false,
}) => {
  const baseClasses = 'casino-card';
  const hoverClasses = hover ? 'hover:transform hover:scale-105 transition-transform duration-300' : '';
  const glowClasses = glow ? 'glow-effect' : '';

  return (
    <div className={`${baseClasses} ${hoverClasses} ${glowClasses} ${className}`}>
      {children}
    </div>
  );
};

export default Card;
